<template>
    <v-progress-circular
        :size="size"
        :width="width"
        color="primary"
        indeterminate
    ></v-progress-circular>
</template>
<script>

export default {
    props: {
        size: {
            type: Number,
            default: 100
        },
        width: {
            type: Number,
            default: 7
        }
    },
    setup() {

    }
}
</script>